export default "__VITE_ASSET__CmYjAKMY__"